import { format } from "date-fns";

export function getProposalExportFileName(projectNameOrUuid, fileType) {
  return `${projectNameOrUuid}-${format(new Date(), "yyyyMMdd-HH-mm")}.${fileType}`
}